import {
  useApplyNavigation,
  useApplyNavigationPath,
} from "@/composition/use-apply-navigation"
import { useApplicationStore } from "@versatile-credit-apply/sdk"
import type { ComputedRef, MaybeRefOrGetter } from "vue"

const pathGetter = (): MaybeRefOrGetter<string> => {
  const store = useApplicationStore()
  return () => `start/${store.applyMode}`
}

export const useStartProviderApplyPath = (): ComputedRef<string> =>
  useApplyNavigationPath(pathGetter())

export const useStartProviderApply = () => useApplyNavigation(pathGetter())
